import { Box, Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { IconType } from 'react-icons';

interface SidebarItemProps {
  icon?: IconType | any;
  label: string;
  active?: boolean;
  indented?: boolean;
  onClick?: () => void;
  /** Chevron dos grupos, à direita do rótulo. */
  trailing?: ReactNode;
}

/**
 * Linha do menu lateral.
 *
 * Existia em três cópias quase idênticas (Links.tsx, Suporte WhatsApp e Sair), cada uma com
 * seu próprio espaçamento e nenhuma com hover.
 */
export default function SidebarItem({ icon, label, active, indented, onClick, trailing }: SidebarItemProps) {
  return (
    <HStack
      py="8px"
      ps={indented ? '32px' : '12px'}
      pe="12px"
      spacing={0}
      borderRadius="10px"
      cursor="pointer"
      onClick={onClick}
      position="relative"
      bg={active ? 'whiteAlpha.200' : 'transparent'}
      _hover={{ bg: active ? 'whiteAlpha.300' : 'whiteAlpha.100' }}
      transition="background-color 0.15s ease"
    >
      {/* Marcador do item ativo na borda esquerda, junto do recorte do menu — antes ficava
          solto na borda direita, e grupo e folha desenhavam um cada. */}
      <Box
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
        h="20px"
        w="3px"
        borderRadius="0 4px 4px 0"
        bg={active ? 'white' : 'transparent'}
      />
      <Flex
        w="100%"
        alignItems="center"
        minW={0}
      >
        {icon ? (
          <Box
            me="14px"
            alignItems="center"
            display="flex"
            height="22px"
            color={active ? 'white' : 'gray.200'}
            flexShrink={0}
          >
            <Icon
              as={icon}
              width="20px"
              height="20px"
              color="inherit"
            />
          </Box>
        ) : null}
        <Text
          me="auto"
          fontSize="sm"
          noOfLines={1}
          color={active ? 'white' : 'gray.200'}
          fontWeight={active ? 'bold' : 'normal'}
        >
          {label}
        </Text>
        {trailing}
      </Flex>
    </HStack>
  );
}
